import React from "react";
import Image from "react-bootstrap/Image";

export const PopupIconButtonReusable = ({
  onClick,
  image,
  buttonClass,
  titleText,
}) => {
  return (
    <React.Fragment>
      <div
        className={
          buttonClass === "bigButton"
            ? "popup-icon-button"
            : null || buttonClass === "smallButton"
            ? "popup-icon-button-small wait-time-edit"
            : null || buttonClass === "editButton"
            ? "popup-icon-edit-button-small"
            : null
        }
        onClick={onClick}
      >
        <Image
          fluid
          src={image}
          alt="Icon"
          title={titleText}
          //className="popup-icon-image"
        />
      </div>
    </React.Fragment>
  );
};
